import HttpFactory from 'http-service-v3'
export default function datafeedFactory() {
    const http = HttpFactory()
    return {
      fetchQuickStartSample(datafeedObj) {
        return http
          .get(http.wsaDomain + `/datafeeds/v3/quickstartsamplefetch/${btoa(JSON.stringify(datafeedObj))}`)
          .then(response => { return response.data })
      },
      getShopifyInventorySample(connectionCode) {
        return http
          .get(http.wsaDomain + `/datafeeds/v3/getshopifyinventorysample/${connectionCode}`)
          .then(response => { return response.data })
      },
    }
  }